import { useContext, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { CModal, BtnLoader } from "../../components";
import { ConvertStringDateToNumberDate } from "../../utils";
import { toast } from 'react-toastify';


interface IProps {
    visible: boolean,
    setVisible: (bol: boolean) => void,
    setDateKeeper: (obj: any) => void,
    dateKeeper: any,
    btnLoader: boolean,
    onFinish?:()=>void ,
}


export const ModalFilterDate = ({ visible, setVisible, dateKeeper, setDateKeeper, btnLoader , onFinish }: IProps) => {

    const handelChangeTime = (e: any, type: string) => {
        let data = { ...dateKeeper };
        data[type] = new Date(e?.toDate?.().toString())
        data[`${type}_jalali`] = ConvertStringDateToNumberDate(e?.toDate?.().toString())
        setDateKeeper(data)
    }

    const handelOnFinish=()=>{
        if(dateKeeper?.end && dateKeeper?.start){
            setVisible(false)
            onFinish?.()
        }
        else {
            toast('تاریخ شروع یا پایان وارد نشده است', { type: "error" })
        }
    }

    return (
        <CModal visible={visible} setVisible={setVisible} uId={'rollcal-date'} title='فیلتر بر اساس تاریخ' >
            <div className="w-full flex flex-col">
                <div className="filteDate w-full flex flex-col mb-3 mt-2">
                    <span className="text-xs text-gray-500 mb-2">تاریخ شروع</span>
                    <DatePicker className="" calendar={persian} locale={persian_fa} value={dateKeeper?.start} onChange={(e: any) => handelChangeTime(e, 'start')} />
                </div>
                <div className="filteDate w-full flex flex-col mb-3 mt-2">
                    <span className="text-xs text-gray-500 mb-2">تاریخ پایان</span>
                    <DatePicker calendar={persian} locale={persian_fa} value={dateKeeper?.end} onChange={(e: any) => handelChangeTime(e, 'end')} />
                </div>
                <div className="w-full flex items-center justify-center mt-4">
                    {btnLoader ?
                        <button className="w-full mx-1 h-[40px] bg-dayan-orange-50 rounded-md text-white text-xs flex items-center justify-center cursor-not-allowed"><BtnLoader /></button>
                        :
                        <button onClick={handelOnFinish} className="w-full mx-1 h-[40px] bg-dayan-orange-50 rounded-md text-white text-xs">اعمال</button>
                    }
                    {btnLoader ?
                        <button  className="w-full mx-1 h-[40px] border border-dayan-orange-50 rounded-md text-dayan-orange-50 text-xs cursor-not-allowed">انصراف</button>
                        :
                        <button onClick={() => { setVisible(false) }} className="w-full mx-1 h-[40px] border border-dayan-orange-50 rounded-md text-dayan-orange-50 text-xs">انصراف</button>
                    }
                </div>
            </div>
        </CModal>
    );
}